import { render, staticRenderFns } from "./ApplicantsRateCountPerRateCard.vue?vue&type=template&id=0cfc720e&"
import script from "./ApplicantsRateCountPerRateCard.vue?vue&type=script&lang=js&"
export * from "./ApplicantsRateCountPerRateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports